import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CompanyContactService } from '../_services';
import * as CompanyContactActions from '../_actions/companyContact';

@Injectable({
  providedIn: 'root',
})
export class CompanyContactEffects {
  loadCompanyContacts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyContactActions.loadCompanyContacts),
      mergeMap(() =>
        this.companyContactService.getCompanyContacts().pipe(
          map((companyContacts) =>
            CompanyContactActions.loadCompanyContactsSuccess({ companyContacts })
          ),
          catchError((error) => of(CompanyContactActions.loadCompanyContactsFailure({ error })))
        )
      )
    )
  );

  addCompanyContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyContactActions.addCompanyContact),
      mergeMap(({ companyContact }) =>
        this.companyContactService.saveCompanyContact(companyContact).pipe(
          map((savedCompanyContact) =>
            CompanyContactActions.addCompanyContactSuccess({ companyContact: savedCompanyContact })
          ),
          catchError((error) => of(CompanyContactActions.addCompanyContactFailure({ error })))
        )
      )
    )
  );

  updateCompanyContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyContactActions.updateCompanyContact),
      mergeMap(({ companyContact }) =>
        this.companyContactService.saveCompanyContact(companyContact).pipe(
          map((updatedCompanyContact) =>
            CompanyContactActions.updateCompanyContactSuccess({
              companyContact: updatedCompanyContact,
            })
          ),
          catchError((error) => of(CompanyContactActions.updateCompanyContactFailure({ error })))
        )
      )
    )
  );

  deleteCompanyContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyContactActions.deleteCompanyContact),
      mergeMap(({ id }) =>
        this.companyContactService.deleteCompanyContact(id).pipe(
          map(() => CompanyContactActions.deleteCompanyContactSuccess({ id })),
          catchError((error) => of(CompanyContactActions.deleteCompanyContactFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private companyContactService: CompanyContactService
  ) {}
}
